import React from "react";

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog } from 'primereact/confirmdialog';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

import UserContext from '../context/UserContext';

class RiskDialog extends React.Component {

	static contextType = UserContext;

	state = {
		riskID: 0,
		name: '',
		process: '',
		category: 1,
		owner: 0,
		description: '',
		rootCause: '',
		potentialConsequence: '',
		probability: 1,
		consequence: 1,
		probabilityAfter: 1,
		consequenceAfter: 1,
		processList: [],
		processSuggestions: [],
		roleList: [],
		categoryList: [],
		hasChanged: false,
	};

	componentDidMount() {
		this.fetchRiskDetails(this.state.riskID);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.riskID !== this.props.riskID && this.props.riskID>=0) {
			this.setState({ riskID: this.props.riskID });
			this.setState({ hasChanged: false });
			this.fetchRiskDetails(this.props.riskID);
		}
	}


	fetchRiskDetails(id) {
		this.setState({ isLoadingData: true });
		fetch('api/Risk/GetRiskDetails/' + id, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ categoryList: data.categoryList });
				this.setState({ processList: data.processList });
				this.setState({ roleList: data.roleList });

				this.setState({ riskID: data.risk.riskID });
				this.setState({ name: data.risk.name });
				this.setState({ process: data.risk.process });
				this.setState({ category: data.risk.category });
				this.setState({ owner: data.risk.owner });
				this.setState({ description: data.risk.description });
				this.setState({ rootCause: data.risk.rootCause });
				this.setState({ probability: data.risk.probability });
				this.setState({ consequence: data.risk.consequence });
				this.setState({ coeditors: data.risk.coeditors });
				this.setState({ hasMitigation: data.risk.hasMitigation });
				this.setState({ probabilityAfter: data.risk.probabilityAfter });
				this.setState({ consequenceAfter: data.risk.consequenceAfter });

				this.preSetOwner(data.roleList);

				this.setState({ isLoadingData: false });
				//console.log(data);
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchProcessList() {
		this.setState({ isLoadingData: true });
		fetch(`api/Risk/GetCategoryList`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ categoryList: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchCategoryList() {
		this.setState({ isLoadingData: true });
		fetch(`api/Risk/GetProcessList`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ processList: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchRoles() {
		this.setState({ isLoadingData: true });
		fetch('api/UserRoles/GetListofRoles', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ roleList: data });
				this.setState({ isLoadingData: false });
				this.preSetOwner(data);
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
				//Gör något om fel
			})
	}

	newRisk() {
		this.setState({ isLoadingData: true });

		const riskDetails = {
			riskID: this.state.riskID,
			name: this.state.name,
			process: this.state.process,
			category: this.state.category,
			owner: this.state.owner,
			coeditors: [],
			description: this.state.description,
			rootCause: this.state.rootCause,
			potentialConsequences: this.state.potentialConsequence,
			probability: this.state.probability,
			consequence: this.state.consequence,
			hasMitigation: this.state.hasMitigation,
			probabilityAfter: this.state.probabilityAfter,
			consequenceAfter: this.state.consequenceAfter,
		}

		fetch('api/Risk/AddRisk', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(riskDetails) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ riskID: data });
				
				this.setState({ isLoadingData: false });
				if (this.props.onClose != null) {
					this.props.onClose(true, data);
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
				//Gör något om fel
			})
	}

	saveRisk() {
		this.setState({ isLoadingData: true });

		const riskDetails = {
			riskID: this.state.riskID,
			name: this.state.name,
			process: this.state.process,
			category: this.state.category,
			owner: this.state.owner,
			coeditors: [],
			description: this.state.description,
			rootCause: this.state.rootCause,
			potentialConsequences: this.state.potentialConsequence,
			probability: this.state.probability,
			consequence: this.state.consequence,
			hasMitigation: this.state.hasMitigation,
			probabilityAfter: this.state.probabilityAfter,
			consequenceAfter: this.state.consequenceAfter,
		};

		fetch('api/Risk/SaveRisk', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(riskDetails) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}

				this.setState({ isLoadingData: false });
				if (this.props.onClose != null) {
					this.props.onClose(true);
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
				//Gör något om fel
			})
	}

	preSetOwner(roles) {
		if (roles.length > 0 && this.state.riskID===0) {
			const user = this.context.user;
			if (user.roleList.length === 0) {
				this.setState({owner: roles[0].roleID})
			} else {
				const ownerSuggestion = roles.find(role => { return user.roleList.find(userRole => userRole.roleID === role.roleID) });
				this.setState({ owner: ownerSuggestion.roleID });
			}
		}
	}

	cancelDialog() {
		if (this.props.onClose != null) {
			this.props.onClose(false);
		}
	}

	closeDialog() {;
		this.newRisk();
	}


	render() {
		const riskBgColor = RiskLevels[this.state.consequence - 1][this.state.probability - 1].bgColor;
		const riskColor = RiskLevels[this.state.consequence - 1][this.state.probability - 1].color;
		
		const footerContent = (
			<div>
				<Button label="Cancel" icon="pi pi-times" onClick={() => this.cancelDialog()} className="p-button-secondary" />
				<Button label="Create" icon="pi pi-check" onClick={() => this.closeDialog()} disabled={!this.state.hasChanged} />
			</div>
		);

		return (
			<Dialog header="New risk" visible={this.props.visible} style={{ width: '25rem', height: '34rem', overflow: 'hidden' }} maximizable footer={footerContent} 
				modal contentStyle={{ height: '300px' }} closable={false} >
				<ConfirmDialog />

				<div className="p-fluid md:w-20rem">
					<div className="p-field">
						<label className="p-field-label">Name</label>
						<InputText value={this.state.name} maxLength="50" onChange={(e) => { this.setState({ name: e.target.value }); this.setState({ hasChanged: true }); }} autoFocus className="w-full md:w-20rem" />
					</div>

					<div className="p-field">
						<label className="p-field-label">Owner</label>
						<Dropdown value={this.state.owner} onChange={(e) => { this.setState({ owner: e.value }); this.setState({ hasChanged: true }); }} options={this.state.roleList} optionValue="roleID" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
					</div>

					<div className="p-field">
						<label className="p-field-label">Probability</label>
						<Dropdown value={this.state.probability} onChange={(e) => { this.setState({ probability: e.value }); this.setState({ hasChanged: true }); }} options={ProbabilityLevels} optionLabel="text" optionValue="id" placeholder=" " className="w-full md:w-20rem" />
					</div>

					<div className="p-field">
						<label className="p-field-label">Consequence</label>
						<Dropdown value={this.state.consequence} onChange={(e) => { this.setState({ consequence: e.value }); this.setState({ hasChanged: true }); }} options={ConsequenceLevels} optionLabel="text" optionValue="id" placeholder=" " className="w-full md:w-20rem" />
					</div>

					<div className="p-field">
						<label className="p-field-label">Risk</label>
						<InputText value={RiskLevels[this.state.consequence - 1][this.state.probability - 1].label} style={{ backgroundColor: riskBgColor, color: riskColor }} className="w-full md:w-20rem" />
					</div>

				</div>
			</Dialog>
		)
	}
}

export default (RiskDialog);